export default
{
	LETTERS: 'letters',
	EMAIL: 'email',
	PHONE: 'phone',
	TIME: 'time'
};